<app-header *ngIf="showHeader" fxLayout="column" class="header"></app-header>

<div fxLayout="row" fxFlex="100" class="w-100">
    <div class="content w-100" fxLayout="column" fxFlex>
        <router-outlet></router-outlet>
    </div>
</div>

<app-footer *ngIf="showFooter" fxLayout="column"></app-footer>

<div id="container" *ngIf="maintenance" class="display-dialog">
    <div class="dialog">
        <div *ngComponentOutlet="activeComponent"></div>
    </div>
</div>
